export default function Loading() {
  return (
    <div data-imp="components/ui/loading.tsx:3:5" className="flex items-center justify-center h-64">
      <div data-imp="components/ui/loading.tsx:4:7" className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
    </div>
  );
}
